<div class="header-media-type-select" *ngIf="form.value as header">
  <button
    [disabled]="form.disabled"
    [class.invalid]="form.dirty && !header.media_id"
    [class.active]="header.media_id && header.media_type === AttachmentType.Image"
    mat-raised-button
    type="button"
    (click)="selectMedia()">
    <mat-icon>image</mat-icon>
  </button>

  <button
    [disabled]="!header.media_id"
    mat-raised-button
    color="primary"
    type="button"
    (click)="deleteMedia()"
    translate="parameters/kakaotalk-templates/content/header/delete-image"></button>
</div>
<input #fileInput (change)="uploadMedia($event)" [accept]="supportedMediaTypes" hidden type="file" />

<div>
  <mat-hint>
    <span>{{ 'parameters/kakaotalk-templates/content/header/hint' | translate }} </span>
  </mat-hint>
</div>

<mat-checkbox class="static-header-option" [formControl]="$any(form.controls.static)">
  <span translate="parameters/whatsapp-templates/content/header/static-header"></span>
</mat-checkbox>
